import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import AzureAPIService, { setAzureAuthToken } from "./AzureAPIService";
import DebugService from "./DebugService";

/**
 * @description ROI Api Service
 */
const RoiApiService = {

  getSavingPlans: async (dataRequest) => {
    try {
      let url = APIConstants.ENDPOINT_ROI_SAVING_PLANS

      return await APIService.post(url, dataRequest)
    } catch (err) {
      DebugService.error(`ROI Api Service: Error Caught while fetching data`, err)
    }
  },

  getAzureSavingPlans: async (dataRequest) => {
    try {
      let url = APIConstants.ENDPOINT_AZURE_ROI_SAVING_PLANS

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, dataRequest)
    } catch (err) {
      DebugService.error(`ROI Api Service: Error Caught while fetching azure data`, err)
    }
  },
}

export default RoiApiService;
